(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["@makolab/library-react/dist/OneFooterFooterLegal"] = factory();
	else
		root["@makolab/library-react/dist/OneFooterFooterLegal"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/project_fcn_library-react/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 331);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/styles");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("lodash/flow");

/***/ }),

/***/ 331:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FooterLegal", function() { return FooterLegal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flow__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_flow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__footer_legal_jss__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__footer_legal_types__ = __webpack_require__(333);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FooterLegal=function(_Component){_inherits(FooterLegal,_Component);function FooterLegal(){_classCallCheck(this,FooterLegal);return _possibleConstructorReturn(this,(FooterLegal.__proto__||Object.getPrototypeOf(FooterLegal)).apply(this,arguments));}_createClass(FooterLegal,[{key:'render',value:function render(){var _props=this.props,classes=_props.classes,legal=_props.legal;var actualYear=new Date().getFullYear();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.root)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.list)},legal&&legal.links.map(function(link,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:key,className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.elem)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{classes:{root:classes.link,label:classes.linkLabel},disableFocusRipple:true,disableRipple:true,href:link.url,target:link.openInNewTab?'_blank':'_self',component:'a',variant:'text'},link.text));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.copyright,classes.copyRenault),variant:'body2',component:'span'},'\xA9 renault 2017 - ',actualYear),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.copyright,classes.copyDacia),variant:'body2',component:'span'},'\xA9 dacia 2017 - ',actualYear));}}]);return FooterLegal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FooterLegal.displayName='FooterLegal';FooterLegal.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,legal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_8__footer_legal_types__["a" /* FOOTER_LEGAL_PROP_TYPE */]).isRequired};/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_3_lodash_flow___default()([Object(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__["withStyles"])(__WEBPACK_IMPORTED_MODULE_7__footer_legal_jss__["a" /* default */])])(FooterLegal));

/***/ }),

/***/ 332:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* harmony default export */ __webpack_exports__["a"] = (function(theme){var _ref,_ref3;var themeName=theme.themeName;var style={root:Object.assign(_defineProperty({borderTop:'1px solid '+theme.palette.common.legalBorder,marginTop:'auto',display:'flex',flexDirection:'column'},theme.breakpoints.up('sm'),Object.assign({flexDirection:'row',alignItems:'center'},themeName==='Renault One'?{padding:theme.spacing.unit+'px '+theme.spacing.unit*8+'px'}:{})),themeName==='Renault One'?{padding:theme.spacing.unit}:(_ref={padding:theme.spacing.unit+'px '+theme.spacing.unit*5+'px '+theme.spacing.unit*2+'px '+theme.spacing.unit*3+'px'},_defineProperty(_ref,'@media (max-width: '+theme.breakpoints.values.sm+'px)',{paddingLeft:theme.spacing.unit*2}),_defineProperty(_ref,theme.breakpoints.up('lg'),{padding:theme.spacing.unit+'px '+theme.spacing.unit*8+'px '+theme.spacing.unit*2+'px '+theme.spacing.unit*8+'px'}),_ref)),list:Object.assign({display:'flex',flexDirection:'column',flex:1,margin:0},themeName==='Renault One'?_defineProperty({padding:theme.spacing.unit},theme.breakpoints.up('sm'),{padding:0,flexDirection:'row'}):(_ref3={flexDirection:'row'},_defineProperty(_ref3,'@media (max-width: '+theme.breakpoints.values.sm+'px)',{flexDirection:'column',paddingInlineStart:0}),_defineProperty(_ref3,theme.breakpoints.up('sm'),{padding:0}),_defineProperty(_ref3,theme.breakpoints.up('lg'),{padding:theme.spacing.unit*4+'px 0 0 '+theme.spacing.unit*2+'px '}),_ref3)),elem:Object.assign({position:'relative',padding:theme.spacing.unit/2+'px '+theme.spacing.unit*2+'px '+theme.spacing.unit/2+'px 0',display:'inline-block',color:'inherit',whiteSpace:'nowrap'},themeName==='Renault One'?{}:{'&:before':{display:'none'}},_defineProperty({'&:not(:last-child)::before':{top:'50%',right:'8px',width:1,height:12,content:'""',position:'absolute',transform:'translateY(-50%)',backgroundColor:theme.palette.primary.contrastText}},'@media (max-width: '+theme.breakpoints.values.sm+'px)',{'&::before':{display:'none'}})),link:Object.assign({margin:0,padding:0,minWidth:'initial',color:theme.palette.common.legal,'&:after':{position:'absolute',bottom:-2,left:0,width:0,height:1,transition:'all .2s',backgroundColor:theme.palette.primary.contrastText,content:'""'},'&:hover:after':{width:'100%'},'&:hover':{backgroundColor:'transparent'}},themeName==='Renault One'?{}:{fontWeight:400}),linkLabel:{textTransform:'none'},copyright:_defineProperty({color:'inherit',fontWeight:700,paddingLeft:theme.spacing.unit},theme.breakpoints.up('xs'),{textTransform:'capitalize'}),copyDacia:_defineProperty({display:'block',fontSize:10,fontWeight:500},'@media (max-width: '+theme.breakpoints.values.sm+'px)',{paddingTop:theme.spacing.unit*3,paddingLeft:0}),copyRenault:{display:'block'}};if(theme.themeName==='Renault One'){style.copyDacia.display='none';style.link.fontSize='12px';style.linkLabel.position='relative';style.linkLabel.top=0;style.linkLabel.height=15;style.copyright.fontSize='12px';style.elem.padding='3px 16px 3px 0';}if(theme.themeName==='Dacia One'){style.copyRenault.display='none';}return style;});

/***/ }),

/***/ 333:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LEGAL_LINKS_PROP_TYPES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FOOTER_LEGAL_PROP_TYPE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var LEGAL_LINKS_PROP_TYPES={'@id':__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,url:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,openInNewTab:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,text:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string};var FOOTER_LEGAL_PROP_TYPE={links:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape(LEGAL_LINKS_PROP_TYPES))};

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/Typography");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/Button");

/***/ })

/******/ });
});
//# sourceMappingURL=OneFooterFooterLegal.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@makolab/library-react/dist/OneFooterFooterLegal.js
// module id = 625
// module chunks = 0